

function SquareButton(props) {

  return (

    <div className={props.ElemClass + " transition-all duration-500"}>
      <div onClick={props.onClick} className={props.classAdd + " hover:cursor-pointer text-xs  md:text-xl   flex flex-row justify-center items-center  "}>
        <div className={props.Accent + " basis-1/12 md:basis-5 lg:basis-5 xl:basis-5 self-stretch flex-shrink-0  "}></div>
        <div className={" flex flex-col gap-0 flex-grow flex-shrink-0"}>
          <div className={" px-1 md:px-3 py-2 md:py-4 flex-grow"}>

            {props.name}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SquareButton;
